if(jQuery('.more-products__slider').length) {
    jQuery('.more-products__slider').slick({
        swipe: true,
        dots: true,
        speed: 300,
        dotsClass: 'slick-dots hero-slider__dots',
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
        ]
    });
}